import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { GlobalStateProvider } from "./providers/GlobalStateProvider";
import { Config } from "./types/config";

const init = (config: Config) => {
  const root = createRoot(document.getElementById("nut-widget-container")!);

  if (!config) return;

  root.render(
    <StrictMode>
      <GlobalStateProvider>
        <App {...config} />
      </GlobalStateProvider>
    </StrictMode>,
  );
};

window.nutInit = init;
export default init;
